import { render } from "./FormItems.vue?vue&type=template&id=41840b39&scoped=true"
import script from "./FormItems.vue?vue&type=script&lang=js"
export * from "./FormItems.vue?vue&type=script&lang=js"

import "./FormItems.vue?vue&type=style&index=0&id=41840b39&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41840b39"],['__file',"src/components/h5/layout/FormItems.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41840b39"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41840b39', __exports__)) {
    api.reload('41840b39', __exports__)
  }
  
  module.hot.accept("./FormItems.vue?vue&type=template&id=41840b39&scoped=true", () => {
    api.rerender('41840b39', render)
  })

}


export default __exports__